
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



var parallaxAnimate = true;
function scrollDown(hash,event,time){
    var section = $(hash);
    if(hash == ''){
      if(event){
        event.preventDefault();
      }
    }
    if ($(window).width() < 769) {
      var headerHeight = 50;
    } else {
      var headerHeight = 62;
    }
    if(!time){
      time = 300;
    }
    if (hash && section.length) { 
      if(event){
        event.preventDefault();
      }
      if(hash.includes('accordion')){
        $('.faq-tab:not('+hash+')').removeClass('active');
        $('.faq-tab:not('+hash+')').find('.faq-contents').addClass('no-transition').outerHeight(0).removeClass('no-transition');
      }
      $('html, body').animate({
        scrollTop: section.offset().top - headerHeight
      }, time, 'linear', function(){
        
        window.parallaxAnimate=true;
        if(hash.includes('accordion')){
          if(hash.indexOf("accordion") > 0){
            section.find('.faq-heading').trigger('click');
          }
        }
        
      });
    }
  }
function transactionSidebar(hash) {
  var linkLabel = 'Get in Touch';
  $('.Drawer__Close[data-drawer-id="sidebar-cart"]').trigger('click');
  $('.Drawer__Close[data-drawer-id="forms-sidebar"]').trigger('click');

  $('#transactions-sidebar').attr('aria-hidden', false);
  $('#transactions-sidebar .transactions-sidebar-content').hide();
  $('#transactions-sidebar #transactions-enquiry').show();
  $('#transactions-sidebar #transactions-enquiry #enquiry-title').text(linkLabel);
  $('#transactions-sidebar').find('.contact-feedback').text('').removeClass('error').removeClass('success');
  $('#transactions-sidebar input:not([type="hidden"]),#transactions-sidebar textarea').val('');
      
  if(hash == '#sidebar-form-add-asset'){
    $('#transactions-sidebar .Drawer__Header h4').text('Add Asset');
    $('#add-asset-form').show();
    $('#enquiry-form').hide();
  }else{
    $('#transactions-sidebar .Drawer__Header h4').text('Transactions Enquiry');
    $('#add-asset-form').hide();
    $('#enquiry-form').show();
  }
  $('#enquiry-form .enquiry-title').val('None');
  $('.PageOverlay').addClass('is-visible transactions-opened');
  $('html').addClass('no-scroll');  
}
function formSidebar(formTitle,formID,linkLabel) {
  if(linkLabel.includes('EMAIL')){
    linkLabel = 'Get in Touch';
  }
  $('.Drawer__Close[data-drawer-id="sidebar-cart"]').trigger('click');
  $('.Drawer__Close[data-drawer-id="transactions-sidebar"]').trigger('click');

  $('#forms-sidebar').attr('aria-hidden', false);
  $('#forms-sidebar .transactions-sidebar-content').hide();
  $('#forms-sidebar #forms-enquiry').show();
  $('#forms-sidebar #forms-enquiry #enquiry-title').text(linkLabel);
  $('#forms-sidebar').find('.contact-feedback').text('').removeClass('error').removeClass('success');
  $('#forms-sidebar input:not([type="hidden"]):not([type="checkbox"]),#forms-sidebar textarea').val('');

  $('#forms-sidebar .Drawer__Header h4').text(formTitle + ' Enquiry');
  $('.sidebar-form-element').hide().removeClass('active');
  $('.sidebar-form-element[data-id="'+formID+'"]').show().addClass('active');
  $('.PageOverlay').addClass('is-visible forms-opened');
  $('html').addClass('no-scroll');
}

function matchSize(firstEl,secondEl,minWidth){
  /*const firstHeight = firstEl.height();
  const secondHeight = secondEl.height();
  const tallest = (firstHeight > secondHeight) ? firstHeight : secondHeight;
  if(minWidth){
    firstEl.removeAttr('style');
    secondEl.removeAttr('style');
    if($(window).width() > minWidth){
      firstEl.height(tallest);
      secondEl.height(tallest);
    }
  }else{
    firstEl.height(tallest);
    secondEl.height(tallest);
  }*/
  
}

window.onload = function () {
  var wUrl = window.location.href;
  if(wUrl.includes('?service=')){
    var hash = wUrl.split('?');
    hash = hash[1].replace('service=','#accordion-');
	  scrollDown(hash);
  }else if(wUrl.includes('#')){
    var hash = wUrl.split('#');
    if(hash[1] != ''){
      hash = '#'+hash[1];
      if(wUrl.includes('#sidebar')){
        if(hash == '#sidebar-form-add-asset' || hash == '#sidebar-form-transactions'){
          transactionSidebar(hash);
        }else{
          var formTitle = hash.replace('#sidebar-form-','').replace('-',' ');
          var formID = hash.replace('#sidebar-form-','');
          var linkLabel = 'Get in Touch';
          formSidebar(formTitle,formID,linkLabel);
        }
      }else{
        scrollDown(hash);
      }
    }
    
  }
};
$( window ).resize(function() {
  if ($(window).width() < 769) {
    $('.random-slider-item.appear2').removeClass('appear2');
  }
  let resizeTimeout;
  if($('.blog-section').length){
    const sectionTitle = $('.blog-section').find('.section-title');
    const tagsWrapper = $('.blog-section').find('.tags-wrapper');
    clearTimeout(resizeTimeout);
    sectionTitle.removeAttr('style');
    tagsWrapper.removeAttr('style');
    resizeTimeout = setTimeout(function() {
      matchSize(sectionTitle,tagsWrapper,900);
    }, 300);
  }
  if($('.media-list-v2').length){
    const sectionTitle = $('.media-list-v2').find('.section-title');
    const tagsWrapper = $('.media-list-v2').find('.tags-wrapper');
    clearTimeout(resizeTimeout);
    sectionTitle.removeAttr('style');
    tagsWrapper.removeAttr('style');
    resizeTimeout = setTimeout(function() {
      matchSize(sectionTitle,tagsWrapper,900);
    }, 300);
  }

});
$(document).ready(function(){
  const urlParams = new URLSearchParams(window.location.search);
  const gclid = urlParams.get("gclid");
  if (gclid) {
    sessionStorage.setItem("gclid", gclid);
  }  


  function removeItem(){
    $.getJSON(window.cartURL, function(result){
      $.each(result.items, function(i, item){
        if(item.product_type == "Form"){
          var line_id = i + 1;
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              'line': line_id,
              'quantity': 0
            },
            success: function (response) {
              console.log(response);
            },
            error: function (xhr, ajaxOptions, thrownError) {
            }
          });
        }
      });
    });
  }
  removeItem();
  if($('.random-slider').length){
    $('.random-slider').each(function(){
      var total = parseInt($(this).attr('data-total'));
      var t = $(this);
      var min = parseInt($(this).attr('data-min'));
      var max = parseInt($(this).attr('data-max'));
      
      var prevn,rand,rand2;
      function switchBoxes(className,offsetTop,offsetBottom){
        var n = Math.floor((Math.random() * total));
        if(n == prevn){
          n = Math.floor((Math.random() * total));
        }
        var top = Math.floor((Math.random() * (parseInt(offsetTop)-parseInt(offsetBottom)+1) + parseInt(offsetBottom)))+'%';
        if ($(window).width() < 641) {
          var left = Math.floor((Math.random() * (70-40+1) + 35))+'%';
        }else if ($(window).width() > 768) {
          var left = Math.floor((Math.random() * (45-40+1) + 40))+'%';
        }else{
          var left = Math.floor((Math.random() * (80-40+1) + 25))+'%';
        }
        t.find('.random-slider-item').removeClass(className);
        t.find('.random-slider-item:eq('+n+')').addClass(className);
        t.find('.random-slider-item:eq('+n+')').css({
          'top':top,
          'left':left
        });
        prevn = n;
      }
      function boxesRepeat(){
        switchBoxes('appear',0,25);
        rand = Math.floor(Math.random() * (max - min + 1)  + min);
        setTimeout(boxesRepeat, rand * 1000);
      }
      function boxesRepeat2(){
        if ($(window).width() > 768) {
          switchBoxes('appear2',55,70);
          rand2 = Math.floor(Math.random() * (max - min + 1)  + min);
        }else{
          $('.random-slider-item.appear2').removeClass('appear2');
        }
        setTimeout(boxesRepeat2, rand2 * 1000);
      }
      switchBoxes();
      boxesRepeat();
      setTimeout(boxesRepeat2, rand * 1000 /2);
    });
  }
  if($('.media-slider').length){
    $('.media-center:not(.landing) .media-slider').each(function(){
      var total = parseInt($(this).attr('data-total'));
      var t = $(this);
      $(this).flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: true,
        groupCells: 1,
        on: {
          ready: function() {
            t.find('.flickity-prev-next-button.previous').prop('disabled','disabled');
          },
          change: function(index) {
            var i = parseInt(index);
            var perSlide = 3;
            if ($(window).width() < 641) {
               perSlide = 1;
            }else if ($(window).width() < 1139) {
               perSlide = 2;
            } 
            var max = total - perSlide;
            if(i > 0){
              t.find('.flickity-prev-next-button.previous').prop('disabled',false);
              t.parents('.media-center-wrapper').addClass('title-hidden');
            }
            if(i == 0){
              t.find('.flickity-prev-next-button.previous').prop('disabled','disabled');
              t.parents('.media-center-wrapper').removeClass('title-hidden');
            
            }
            t.find('.flickity-prev-next-button').prop('disabled','disabled');
          },
          settle: function(index) {
            t.find('.flickity-prev-next-button').prop('disabled',false);
            
            
            var totalPlus = total + 1;
            if(index > totalPlus){
              $(this)[0].selectCell(2,false,true);
              t.find('.flickity-prev-next-button').prop('disabled',false);
            }
          }
          
        }
      });
    });
    $('.media-center.landing .media-slider').each(function(){
      $(this).flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        watchCSS: true,
        groupCells: 1
      });
    });
  }
  if($('.icon-columns').length){
    $('.icon-columns-section.landing .icon-columns').each(function(){
      $(this).flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        watchCSS: true,
        groupCells: 1
      });
    });
  }
  if($('.advisory-canvas').length){
    $('.advisory-canvas canvas').each(function(){
      var coordinates = $(this).attr('data-coordinate').split(',');
      var labels = coordinates;
      var data = {
  		labels: labels,
        datasets: [{
          label: 'Advisory',
          backgroundColor: '#0367fe',
          borderColor: '#0367fe',
          data: coordinates,
          lineTension: 0.36
        }]
      };
      var config = {
        type: 'line',
        data:data,
        options: {
          scales: {
            x: {
              title  :{
                display: false
              },
              ticks :{
                align : 'left',
                display: false
              },
              grid :{
                display: false,
                drawBorder: false
              }
            },
            y: {
              title  :{
                display: false
              },
              ticks :{
                display: false
              },
              grid :{
                display: false,
                drawBorder: false
              }
            }
          },
          grid:{
            display : false
          },
          layout: {
            padding: 0
          },
          plugins: {
            legend: {
              display: false,
            },
            subtitle: {
              display: false,
            },
            title: {
                display: false,
            },
            tooltip :{
              enabled : false
            }
          },
          responsive: true,
     	  maintainAspectRatio: false,
          elements: {
            point:{
              radius: 4,
              hoverRadius : 4
            },
            line :{
              borderWidth : 1
            }
          }
        }
      };
      const advChart = new Chart($(this),config);
    });
    
    $(document).on('click','.advisory-arrows button:not(:disabled)',function(){
      var graph = $(this).parents('.advisory-right').find('.advisory-graph');
      var graphWrapper = $(this).parents('.advisory-right').find('.advisory-graph-wrapper');
      var canvasEl = $(this).parents('.advisory-right').find('.graph-columns');
      var index = parseInt(graph.attr('data-index'));
      var total = parseFloat(graph.attr('data-total')) / 2;
      var totalCeil = Math.ceil(parseInt(graph.attr('data-total')) / 2);
      if($(this).hasClass('next')){
        $(this).prev().removeAttr('disabled');
        index = index + 1;
        if(index >= total){
          index = totalCeil;
          graphWrapper.animate({
            scrollLeft:canvasEl.outerWidth()
          }, 300);
          $(this).attr('disabled','disabled');
        }else{
          var percent = (index-1)/total * 100;
          var movement = percent * canvasEl.outerWidth() / 100;
          graphWrapper.animate({
            scrollLeft: movement
          }, 300);
        }
      }else{
        $(this).next().removeAttr('disabled');
        index = index - 1;
        if(index < 2){
          index = 1;
          $(this).attr('disabled','disabled');
          graphWrapper.animate({
            scrollLeft:0
          }, 300);
        }else{
          var percent = (index-1)/total * 100;
          var movement = percent * canvasEl.outerWidth() / 100;
          graphWrapper.animate({
            scrollLeft: movement
          }, 300);
        }
      }
      graph.attr('data-index',index);
    });
    
  }
  if($('.team-blocks').length){
  	$('div:not(.landing) .team-blocks:not(.no-slider)').each(function(){
      $(this).flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,
        watchCSS: true
      });
    });
    $('.full-team-section.landing .team-blocks').each(function(){
      window.teamBlockLanding = new Flickity( $(this)[0], {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,        
        watchCSS: true
      });
      
    });
  }
  if($('.slideshow-products-wrapper').length){
  	$('.slideshow-products-wrapper').each(function(){
      var t = $(this);
      $(this).flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,
        watchCSS: true,
        prevNextButtons: false,
        groupCells: 1,
        on: {
          change: function(index) {
            var i = parseInt(index);
            if(i > 0){
              t.prev().addClass('title-hidden');
            }
            if(i == 0){
              t.prev().removeClass('title-hidden');
            }
          }
        }
        
      });
    });
  }
  $(".graph-hover").hover(function(){
    var i = $(this).index();
    $(this).parent().prev().find('.graph-line:eq('+i+')').addClass("hover");
  }, 
  function(){
    var i = $(this).index();
    $(this).parent().prev().find('.graph-line:eq('+i+')').removeClass("hover");
  });
  
  function closeCartDrawer(){
    $('#sidebar-cart').attr('aria-hidden', 'true');
    $(document).removeClass('no-scroll');
    disableBodyScroll(false, '[data-scrollable]');
    $('#shopify-section-header').css('z-index',''); // Ugly hack
    $('.PageOverlay').removeClass('is-visible');
    $('.PageOverlay').off('click');
    $('.Drawer__Close[data-drawer-id="sidebar-cart"]').off('click');
  }
  $(document).on('click','.atc-button.add:not(.enquire-btn):not(.transactions-btn)',function(e){
    e.preventDefault();
    var t = $(this);
    var variant_id = t.attr('data-id');
    t.prop('disabled','disabled');
    if(t.hasClass('atc-with-options')){
      var error = 0;
      var itemProperties = {};
      t.parent().next().find('.product-card-options').each(function(){
        if($(this).is(':visible')){
          if($(this).val() != '' || $(this).attr('data-value')){
            var keyName = $(this).attr('name').replace ('properties[','').slice(0, -1);
            if($(this).val() != ''){
              itemProperties[keyName] = $(this).val();
            }else{
              itemProperties[keyName] = $(this).attr('data-value');
            }
            $(this).removeClass('error');
          }else{
            $(this).addClass('error');
            error++;
          }
        }else{
          $(this).val('');
        }
      });
      
      t.parent().next().find('.uploadkit-uploader').each(function(){
        if($(this).is(':visible')){
          if($(this).hasClass('attached')){
            $(this).removeClass('error');
          }else{
            $(this).addClass('error');
            error++;
          }
        }else{
          $(this).removeClass('attached').find('.uploadkit-attribute-container').empty();
        }
      });
      if(error < 1){
      	var formel = t.parents('.ProductItem__Info').find('.productFormOptions');
        formel.find('[name="id"]').val(variant_id);
        formel.find('.ProductForm__BuyButtons').nextAll('input').remove();

        $.each(itemProperties, function (i, obj) {
          var hiddenEl = '<input type="hidden" name="properties['+i+']" value="'+obj+'"/>';
          formel.append(hiddenEl);
        });
        
        formel.find('.ProductForm__BuyButtons button').trigger('click');
        
        
      }else{
        t.prop('disabled',false);
      }
    }else{
      if($('.popup').length){
        const token = $(this).attr('data-token');
        const title = $(this).attr('data-title');
        const file = atob(token);
        t.removeAttr('disabled');
        $('.popup').find('#hidden').val(file);
        $('.popup').find('#hidden-2').val(title);
        $('.popup').find('form').show();
        $('.popup').find('.message').hide();

        const cookie = document.cookie;
        const cookieArray = cookie.split("; ");
        const cachedCookie = cookieArray.find((c) => c.startsWith("popupFields="));
        if (cachedCookie) {
          const cachedUser = JSON.parse(cachedCookie.split("=")[1]);
          if (new Date(cachedUser.expirationDate) > new Date()) {
            // Use cached values
            const fullName = cachedUser.fullName;
            const email = cachedUser.email;
            const company = cachedUser.company;
            $('.popup').find('[name="text"]').val(fullName);
            $('.popup').find('[name="text-2"]').val(company);
            $('.popup').find('[name="email"]').val(email);
          }
        }

        $('.popup').addClass('show');
      }else{
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: 1,
            id: variant_id
          },
          dataType: 'json',
          success: function() {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
            
            $('.Header__Icon[data-drawer-id="sidebar-cart"]').addClass('added');
            setTimeout(function(){
              $('.Header__Icon[data-drawer-id="sidebar-cart"]').removeClass('added');
            }, 2000);
            
            t.prop('disabled',false).removeClass('add').addClass('remove');
            t.parents('.ProductItem__Wrapper').addClass('added');
            //$('#sidebar-cart').attr('aria-hidden', 'false');
            $('#sidebar-cart').css('max-height', window.innerHeight+'px');
            //$(document).addClass('no-scroll');
            //disableBodyScroll(true, '[data-scrollable]');
            $('#shopify-section-header').css('z-index',''); // Ugly hack
            //$('.PageOverlay').addClass('is-visible');
            //$('.PageOverlay').on('click',closeCartDrawer);
            //$('.Drawer__Close[data-drawer-id="sidebar-cart"]').on('click',closeCartDrawer);
            
          },
          error: function (xhr, ajaxOptions, thrownError) {
            console.log(xhr.status);
            console.log(thrownError);
          }
        });
      }
    }
  });
  $(document).on('click','.popup-close,.popup-overlay',function(){
    $(this).parents('.popup').removeClass('show');
    $('.atc-button:disabled').removeAttr('disabled');
  });

  $(document).on('click','.globo-formbuilder form button.submit',function(){
    const expiration = parseInt($(this).parents('.popup-contents').attr('data-expire'));
    const form = $(this).parents('form');
    let error = 0;
    form.find('.globo-form-control').each(function(){
      if($(this).hasClass('has-error')){
        error++;
      }
    });
    if(error < 1){
      const fullName = form.find('[name="text"]').val();
      const company = form.find('[name="text-2"]').val();
      const email = form.find('[name="email"]').val();
      const expirationDate = new Date(Date.now() + expiration * 24 * 60 * 60 * 1000); // 30 days from now
      const cache = {
        fullName,
        email,
        company,
        expirationDate,
      };
      document.cookie = `popupFields=${JSON.stringify(cache)}; expires=${expirationDate.toUTCString()}; path=/`;
    }
  });
  


  $(document).on('click','.atc-button.remove',function(){
    var t = $(this);
    var variant_id = t.attr('data-id');
    t.prop('disabled','disabled');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        quantity: 0,
        id: variant_id
      },
      dataType: 'json',
      success: function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        $('.Header__Icon[data-drawer-id="sidebar-cart"]').addClass('added');
        setTimeout(function(){
          $('.Header__Icon[data-drawer-id="sidebar-cart"]').removeClass('added');
        }, 2000);
        
        t.prop('disabled',false).removeClass('remove').addClass('add');
        t.parents('.ProductItem__Wrapper').removeClass('added');
        
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log(xhr.status);
        console.log(thrownError);
      }
    });
  });
  
  if($('.graph-canvas').length){
    $('.graph-canvas canvas').each(function(){
      var x_axis_before = $(this).parents('.graph-group').find('.graph-item.active .graph-data').attr('data-x').split('~');
      var x_axis = x_axis_before.map(e => e.split(","));
      var y_axis = $(this).parents('.graph-group').find('.graph-item.active .graph-data').attr('data-y').split('~');
      var max_y = parseInt($(this).parents('.graph-group').find('.graph-item.active .graph-data').attr('data-max'));
      var min_y = parseInt($(this).parents('.graph-group').find('.graph-item.active .graph-data').attr('data-min'));
      if(!min_y){
        min_y = 0;
      }
      
      var data = {
  		labels: x_axis,
        datasets: [{
          label: 'Valuations',
          backgroundColor: '#0367fe',
          borderColor: '#0367fe',
          data: y_axis,
          lineTension: 0
        }]
      };
      var config = {
        type: 'line',
        data:data,
        options: {
          scales: {
            x: {
              ticks :{
                font: {
                  size: '11px',
                  family:'IBM Plex Mono,monospace,sans-serif',
                }
              },
              grid :{
          		drawOnChartArea : false,
                drawBorder: false
              }
            },
            y: {
              suggestedMin : min_y,
              suggestedMax: max_y,
              ticks :{
                font: {
                  size: '11px',
                  family:'IBM Plex Mono,monospace,sans-serif',
                }
              },
              grid :{
                tickColor: 'white',
                drawBorder: false
              }
            }
          },
          plugins: {
            legend: {
              display: false,
            },
            subtitle: {
              display: false,
            },
            title: {
                display: false,
            },
            tooltip:{
              backgroundColor: '#0367fe',
              xAlign:'center',
              yAlign : 'bottom',
              bodyAlign : 'center',
              titleAlign : 'center',
              displayColors : false,
              point:{
                radius: 0
              },
              titleFont :{
                size: '12px',
                weight: '400',
                family:'IBM Plex Mono,monospace,sans-serif'
              },
              bodyFont :{
                size: 12,
                weight: 'bold',
                family:'IBM Plex Mono,monospace,sans-serif'
              },
              callbacks: {
                title : function(context) {
                  let t = context[0].label.replace(',',' ');
                  return t;
                },
                label: function(context) {
                  return context.parsed.y;
                }
              }
            }
          },
          responsive: true,
     	  maintainAspectRatio: false,
          elements: {
            point:{
              radius: 4
            },
            line :{
              borderWidth : 1
            }
          }
        }
      };
      var valuationsChart = new Chart($(this),config);
      $('.graph-select-dropdown li').on('click',function(){
        var val = $(this).text();
        $(this).parent().prev().find('span').text(val);
        $(this).parent().outerHeight(0);

        var elIndex = $(this).index();
        $(this).parents('.graph-group').find('.graph-item').removeClass('active').eq(elIndex).addClass('active');

        var x_axis_before = $(this).parents('.graph-group').find('.graph-item.active .graph-data').attr('data-x').split('~');
        var x_axis = x_axis_before.map(e => e.split(","));
        var y_axis = $(this).parents('.graph-group').find('.graph-item.active .graph-data').attr('data-y').split('~');
        
        valuationsChart.data.labels = x_axis;
        valuationsChart.data.datasets[0].data = y_axis;
        valuationsChart.update();

      });

      $(document).on('click','.vpi-accordion .graph-toggle',function(e){
        var graphTitle = $(this).attr('data-text');
        $('.graph-toggle-active').removeClass('graph-toggle-active');
        $(this).addClass('graph-toggle-active');
        if($(this).hasClass('accordion-group-heading')){
          $(this).addClass('graph-toggle-active');
          $('.accordion-area.expanded').each(function(){
            $(this).removeClass('expanded').outerHeight($(this).find('.building-type').outerHeight()+ 18);
          })
        }

        if($(this).attr('data-x') != ''){
          var x_axis_before = $(this).attr('data-x').split('~');
          var x_axis = x_axis_before.map(e => e.split(","));
          var y_axis = $(this).attr('data-y').split('~');
          var max_y = $(this).attr('data-max');
          var min_y = $(this).attr('data-min');
          if(!min_y){
            min_y = 0;
          }
        }else{
          var parentToggle = $(this).parents('.accordion-group').find('.accordion-group-heading');
          graphTitle = parentToggle.attr('data-text');
          var x_axis_before = parentToggle.attr('data-x').split('~');
          var x_axis = x_axis_before.map(e => e.split(","));
          var y_axis = parentToggle.attr('data-y').split('~');
          var max_y = parentToggle.attr('data-max');
          var min_y = parentToggle.attr('data-min');
          if(!min_y){
            min_y = 0;
          }
        }
        $(this).parents('.vpi-columns').find('.vpi-graph-title').html(`<span>${graphTitle}</span>`);
        
        if($(this).find('.graph-years-select').length){
          var yearsSelect = $(this).find('.graph-years-select').html();
          $(this).parents('.vpi-columns').find('.vpi-graph-title').append(yearsSelect);
        }else if(parentToggle.find('.graph-years-select').length){
          var yearsSelect = parentToggle.find('.graph-years-select').html();
          $(this).parents('.vpi-columns').find('.vpi-graph-title').append(yearsSelect);
        }else{
          $(this).parents('.vpi-columns').find('.vpi-graph-title span:nth-child(2)').remove();
        }
        
        valuationsChart.options.scales.y.suggestedMax = max_y;
        valuationsChart.options.scales.y.suggestedMin = min_y;
        valuationsChart.data.labels = x_axis;
        valuationsChart.data.datasets[0].data = y_axis;
        valuationsChart.update();

        var locationID = parseFloat($(this).attr('data-id'));
        var locationName = $(this).attr('data-name');
        var latitude = parseFloat($(this).attr('data-lat'));
        var longitude = parseFloat($(this).attr('data-long'));
        var zoomLevel = parseFloat($(this).attr('data-zoom'));
        if(!zoomLevel){
          zoomLevel = 12;
        }
        if(latitude && longitude){
          initMap(locationID, locationName, latitude, longitude, zoomLevel);
        }
 

      });

      $(document).on('click','.change-year',function(e){
        e.preventDefault();
        var graphYear = $(this).text();
        $(this).parents('.year-list').find('.year-active span b').text(graphYear);

        if($(this).attr('data-x') != ''){
          var x_axis_before = $(this).attr('data-x').split('~');
          var x_axis = x_axis_before.map(e => e.split(","));
          var y_axis = $(this).attr('data-y').split('~');
          var max_y = $(this).attr('data-max');
        }
        
        valuationsChart.options.scales.y.suggestedMax = max_y;
        valuationsChart.data.labels = x_axis;
        valuationsChart.data.datasets[0].data = y_axis;
        valuationsChart.update();

      });

    });
  }
  if($('.product-card-section').length){
    $('.product-card-section .product-card-products').each(function(){
      var t = $(this);
      var children = t.children().length;
      var maxHeight = -1;
      t.find('.ProductItem').each(function() {
        maxHeight = maxHeight > $(this).outerHeight() ? maxHeight : $(this).outerHeight();
      });
      $(this).flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,
        watchCSS: true,
        on: {
          ready: function( index ) {
            t.find('.flickity-viewport').outerHeight(maxHeight);
            t.find('.ProductItem').each(function() {
              $(this).height(maxHeight);
            });
            
            if(children < 2){
              t.find('.flickity-button').hide();
            }
          },
          resize : function( index ) {
            t.find('.ProductItem').each(function() {
              if($(this).find('.product-options').length){
                maxHeight = $(this).find('.product-options').outerHeight(true);
                $(this).outerHeight(maxHeight);
              }
            });
            
            t.find('.flickity-viewport').outerHeight(maxHeight + 10);
          }
        }
      });
    });
  }
  $('.graph-select-active').on('click',function(e){
    e.stopPropagation();
    var total = 0;
    $('.graph-select-active').not($(this)).next().outerHeight(0).removeClass('expanded');
    if($(this).next().hasClass('expanded')){
      $(this).next().outerHeight(0).removeClass('expanded');
    }else{
      var total = 0;
      $(this).next().children().each(function(){
        total = total + $(this).outerHeight();
      });
      $(this).next().outerHeight(total + 10).addClass('expanded');
    }
  });
  $('.input-select-active').on('click',function(e){
    e.stopPropagation();
    var total = 0;
    $(this).parent().addClass('expanded');
    $(this).parent().siblings().removeClass('expanded');
    $('.input-select-active').not($(this)).next().outerHeight(0).removeClass('expanded');
    if($(this).next().hasClass('expanded')){
      $(this).next().outerHeight(0).removeClass('expanded');
    }else{
      var total = 0;
      $(this).next().children().each(function(){
        if($(this).is(":visible")){
          total = total + $(this).outerHeight();
        }
      });
      $(this).next().outerHeight(total + 10).addClass('expanded');
    }
  });
  $('.input-select-dropdown li').on('click',function(){
    var val = $(this).text();
    
    $(this).parent().prev().attr('data-value',val).find('span').text(val);
    $(this).addClass('selected');
    
    $(this).parents('.product-options-select').siblings().each(function(){
      if($(this).find('li[data-option-group="'+val+'"]').length > 0){
        $(this).removeClass('select-disabled');
        $(this).find('li[data-option-group]').hide();
        $(this).find('li[data-option-group="'+val+'"]').show();
      }  
      var selected = $(this).find('.selected');
      if(!selected.is(":visible")){
        var active_wrapper = $(this).find('.input-select-active span');
        active_wrapper.text(active_wrapper.attr('data-default'));
        $(this).find('.input-select-active').attr('data-value','');
      }  
    })
    
    if($(this).parents('.variant-select').length){
      $(this).parents('.ProductItem__Info').find('.money').text($(this).attr('data-price'));
      $(this).parents('.ProductItem__Info').find('.atc-button').attr('data-id',$(this).attr('data-id'));
    }
    
    $(this).parents('.product-options-select').find('.product-card-options').removeClass('error');
    
    $(this).parent().outerHeight(0);
	$('.product-options-select').removeClass('expanded');

    if($(this).parents('[data-id="type-of-property"]').length){
      if(val=='Villa'){
        $('[data-uploader-id="3fa8b651-1d6f-4e01-af3f-0b9f2e5902f4"]').css('display','flex');
        $('[data-uploader-id="98aaa999-e184-4a09-8a53-d98a3abc22be"]').hide();
      }else if(val=='Land'){
        $('[data-uploader-id="3fa8b651-1d6f-4e01-af3f-0b9f2e5902f4"]').hide();
        $('[data-uploader-id="98aaa999-e184-4a09-8a53-d98a3abc22be"]').css('display','flex');
      }else{
        $('[data-uploader-id="3fa8b651-1d6f-4e01-af3f-0b9f2e5902f4"]').hide();
        $('[data-uploader-id="98aaa999-e184-4a09-8a53-d98a3abc22be"]').hide();
      }
    }
    if($(this).parents('[data-id="type-of-valuation"]').length){
      if(val=='Physical Inspection'){
        $('[data-id="contact-point-name"]').css('display','flex');
        $('[data-id="contact-point-number"]').css('display','flex');
      }else{
        $('[data-id="contact-point-name"]').hide();
        $('[data-id="contact-point-number"]').hide();
      }
    }
    
  });
  
  $(document).on('change','.Form__Input.product-card-options',function(){
    if($(this).val() != ''){
      $(this).removeClass('error')
    };
  });
  $(document).on('click','.Collapsible__Button:not(.filter-mobile):not(.accordion-menu)',function(e){
    e.stopPropagation();
    var form = $('#collection-filters-sidebar-form');
    var total = 0;
    var parentWidth = $(this).parents('.collection-toolbar').outerWidth();
    var t = $(this);
    $('.Collapsible__Button').not(t).parent('.Collapsible').removeClass('expanded');
    if(t.parent().hasClass('expanded')){
      t.next().outerHeight(0);
      setTimeout(function(){
        form.removeClass('expanded');
        t.parent().removeClass('expanded');
      }, 100);
      $('.Collapsible__Button').not(t).parent('.Collapsible').removeClass('expanded');
    }else{
      t.next().find('.Linklist').children().each(function(){
        total = total + $(this).outerHeight();
      });
      form.find('.Collapsible__Inner').outerHeight(0);
      form.addClass('expanded');
      t.next().height(total).parents('.Collapsible').addClass('expanded');
    }
  });
  
  function loopSlider(currentActive){
    if(currentActive.next().length){
      currentActive.removeClass('active').next().addClass('active');
    }else{
      currentActive.removeClass('active').siblings().first().addClass('active');
    }
  }
  if($('.team-group').length){
    $('.team-group').each(function(){
      var delay = parseInt($(this).attr('data-delay'));
      var t = $(this);
      setTimeout(function(){
    	var currentActive = t.find('.active');
        loopSlider(currentActive);
        setInterval(function(){
    	  var currentActive = t.find('.active');
          loopSlider(currentActive);
        }, 10000);
        
      }, delay*2000);
    });
  }
  if($('.clock-group').length){
    $('.clock-item').each(function(){
      var hour = $(this).find('.hour');
      var minute = $(this).find('.minute');
      var offset = parseInt($(this).attr('data-offset'));
      setInterval(function(){
        d = new Date(); //object of date()
        hr = d.getUTCHours() + offset;
        min = d.getUTCMinutes();
        hr_rotation = 30 * hr + min / 2; //converting current time
        min_rotation = 6 * min;
        hour.css('transform', 'rotate('+hr_rotation+'deg)');
        minute.css('transform', 'rotate('+min_rotation+'deg)');
      }, 1000);
    });
  }
  if($('.project-slider').length){
    $('.project-slider-section:not(.landing) .project-slider').each(function(){
      var total = parseInt($(this).attr('data-total'));
      var t = $(this);
      if(t.parents('.product-type').length){
        var children = t.children().length;
        var maxHeight = -1;
      }
      $(this).flickity({
        cellAlign: 'left',
        pageDots: false,
        groupCells: true,
        on: {
          ready: function( index ) {
            if(t.parents('.product-type').length){
              t.find('.ProductItem__Wrapper').each(function() {
                maxHeight = maxHeight > $(this).outerHeight() ? maxHeight : $(this).outerHeight();
                console.log($(this).outerHeight());
              });
              t.find('.flickity-viewport').outerHeight(maxHeight);
              t.find('.ProductItem').each(function() {
                $(this).height(maxHeight);
              });
            }
          },
          resize : function( index ) {
            if(t.parents('.product-type').length){
              t.find('.ProductItem').each(function() {
                if($(this).find('.product-options').length){
                  maxHeight = $(this).find('.product-options').outerHeight(true);
                  $(this).outerHeight(maxHeight);
                }
              });

              t.find('.flickity-viewport').outerHeight(maxHeight + 10);
            }
          },
          change: function( index ) {
            var i = parseInt(index);
            var perSlide = 2;
            if ($(window).width() < 640) {
               perSlide = 1;
            }else if ($(window).width() < 1139) {
               perSlide = 2;
            } 
            var max = total - perSlide;
            if(i > 0){
              t.parents('.project-slider-section').addClass('title-hidden');
            }else{
              t.parents('.project-slider-section').removeClass('title-hidden');
            }
            if(i >= max){
              t.find('.flickity-button.next').prop('disabled','disabled');
            }else{
              t.find('.flickity-button.next').prop('disabled',false);
            }
          }
        }
      });
    });
    $('.project-slider-section.landing .project-slider').each(function(){
      const hasNav = $(this).hasClass('static') ? true : false;
      window.projectsliderLanding = $(this).flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: hasNav,
        pageDots: false,
        wrapAround: false,
        watchCSS: true,
        groupCells: 1
      });
    });
  }

  if($('.text-list-columns').length){
    
    $('.text-list-columns .list-column').each(function(){
      $(this).flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        watchCSS: true,
        groupCells: true
      });
    })
  }

  $(document).on('click','.project-categories li', function(){
    var cat_name = $(this).find('.category-name').text();
    $(this).addClass('active').siblings().removeClass('active');
    $(this).parents('.landing').find('[data-category="'+cat_name+'"]').addClass('active').siblings(':not([data-category="'+cat_name+'"])').removeClass('active');
    if(projectsliderLanding){
      projectsliderLanding.flickity('resize');
    }
  })
  $(document).on('click','.faq-heading:not(.link-heading)',function(e){
    $(this).parent().siblings().removeClass('active');
    $(this).parent().siblings().find('.faq-contents').outerHeight(0);
    var t = $(this);
    var total = 0;
    $(this).next().find('.faq-content-inner').children().each(function(){
      total = total + $(this).outerHeight(true);
    });
    total = $(this).next().find('.faq-content-inner').outerHeight(true);
    
    if(!$(this).parent().hasClass('active') || e.originalEvent == undefined){
      $(this).parent().addClass('active');
      $(this).next().outerHeight(total);
     /* setTimeout(function(){
        $('html, body').animate({
          scrollTop: t.offset().top - 100
        }, 500, 'swing');
      }, 500);*/
      
    }else{
      $(this).parent().removeClass('active');
      $(this).next().outerHeight(0);
    }
  });
  
  $(document).mouseup(function(e) {
    var graphbtn = $(".graph-select-active");
    if (!graphbtn.is(e.target) && graphbtn.has(e.target).length === 0){
      graphbtn.next().outerHeight(0);
      graphbtn.next().removeClass('expanded');
    }
    var inputbtn = $(".input-select-active");
    if (!inputbtn.is(e.target) && inputbtn.has(e.target).length === 0){
      inputbtn.next().outerHeight(0);
      inputbtn.next().removeClass('expanded');
      $('.product-options-select').removeClass('expanded');
    }
    var collapsible = $('#collection-filters-sidebar-form');
    if (!collapsible.is(e.target) && collapsible.has(e.target).length === 0){
      if (!$(e.target).parents('#collection-filters-sidebar-form').length){
        collapsible.find('.Collapsible').removeClass('expanded');
        collapsible.find('.Collapsible__Inner').outerHeight(0);
      }
    }
    
  });
  $(document).on('click', '.collection-filter-mobile button',function(e){
    e.stopPropagation();
    var form = $('#collection-filters-sidebar-form');
    var total = 0;
    var t = $(this);
    if(t.hasClass('expanded')){
      form.outerHeight(0);
      t.removeClass('expanded');
      form.removeClass('expanded');
    }else{
      var removeExpanded = setTimeout(function(){
        t.addClass('expanded');
      	form.addClass('expanded');
        clearTimeout(removeExpanded);
      }, 300);

      var height = form.children(0).outerHeight() + 10;
      var totalChildren = Math.ceil(form.children().length / 2);
      total = height * totalChildren;
      form.outerHeight(total);
    }
    
  });
  $(document).on('click', '.PageOverlay.filter-opened, [data-action="close-drawer"][data-drawer-id="sidebar-filter"]',function(){
    $('.PageOverlay.filter-opened').removeClass('is-visible filter-opened');
    $('#sidebar-filter').attr('aria-hidden', true);
    $('html').removeClass('no-scroll');
  });
  $(document).on('change', '#sidebar-filter .Linklist__Checkbox ',function(){
    var name = $(this).attr('id');
    var id = name.replace('sidebar2','sidebar');
    var count = $('#sidebar-filter .Linklist__Checkbox:checked').length;
    if(count > 0){
      $('.collection-filter-count').removeClass('hidden');
      $('.collection-filter-count span').text(count);
    }else{
      $('.collection-filter-count').addClass('hidden');
    }
    $('#collection-filters-sidebar-form #'+id+' + label' ).trigger('click');
  });
  /*$(document).on('click', '.enquire-button-wrapper',function(e){
    e.preventDefault();
    var btn = $(this).find('.atc-button');
    var product_title = btn.attr('data-title');
    var contact_title = btn.attr('data-contact-title');
    
    $('.Drawer__Close[data-drawer-id="sidebar-cart"]').trigger('click');
    $('.Drawer__Close[data-drawer-id="forms-sidebar"]').trigger('click');
    
    $('#transactions-sidebar').attr('aria-hidden', false);
    $('#transactions-sidebar .transactions-sidebar-content').hide();
    $('#transactions-sidebar #transactions-enquiry').show();
    $('#transactions-sidebar #transactions-enquiry #enquiry-title').text(product_title);
    $('#transactions-sidebar').find('.contact-feedback').text('').removeClass('error').removeClass('success');
    $('#transactions-sidebar input:not([type="hidden"]),#transactions-sidebar textarea').val('');
    if(btn.hasClass('transactions-btn')){
      $('#transactions-sidebar .Drawer__Header h4').text('Add Asset');
      $('#add-asset-form').show();
      $('#enquiry-form').hide();
    }else{
      $('#transactions-sidebar .Drawer__Header h4').text('Transaction Enquiry');
      $('#add-asset-form').hide();
      $('#enquiry-form').show();
      $('#enquiry-form .enquiry-title').val(contact_title);
    }
    
    $('.PageOverlay').addClass('is-visible transactions-opened');
    $('html').addClass('no-scroll');
  });*/
  $(document).on('click', '.PageOverlay.transactions-opened, [data-action="close-drawer"][data-drawer-id="transactions-sidebar"]',function(){
    $('.PageOverlay.transactions-opened').removeClass('is-visible');
    
    setTimeout(function(){
      $('.PageOverlay.transactions-opened').removeClass('transactions-opened');
    },300);
    $('#transactions-sidebar').attr('aria-hidden', true);
    $('html').removeClass('no-scroll');
  });
  $(document).on('click', '.PageOverlay.forms-opened, [data-action="close-drawer"][data-drawer-id="landing-sidebar"]',function(){
    $('.PageOverlay.forms-opened').removeClass('is-visible');
    
    setTimeout(function(){
      $('.PageOverlay.forms-opened').removeClass('forms-opened');
    },300);
    $('#landing-sidebar').attr('aria-hidden', true);
    $('html').removeClass('no-scroll');
  });
  $(document).on('click', '.PageOverlay.account-opened, [data-action="close-drawer"][data-drawer-id="account-sidebar"]',function(){
    $('.PageOverlay.account-opened').removeClass('is-visible');
    setTimeout(function(){
      $('.PageOverlay.account-opened').removeClass('account-opened');
    },300);
    $('#account-sidebar').attr('aria-hidden', true);
    $('html').removeClass('no-scroll');
  });
  $(document).on('click', '.PageOverlay.forms-opened, [data-action="close-drawer"][data-drawer-id="forms-sidebar"]',function(){
    $('.PageOverlay.forms-opened').removeClass('is-visible');
    setTimeout(function(){
      $('.PageOverlay.forms-opened').removeClass('forms-opened');
    },300);
    $('#forms-sidebar').attr('aria-hidden', true);
    $('html').removeClass('no-scroll');
  });
  $(document).on('click', '.account-link.guest',function(e){
    e.preventDefault();
    $('#account-sidebar').attr('aria-hidden', false);
    $('.PageOverlay').addClass('is-visible account-opened');
    $('html').addClass('no-scroll');
  });
  
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  function slideshowResize(){
    if($('.slideshow-links .sublinks').length){
      $('.slideshow-links .sublinks').each(function(){
        var maxHeight = 0;
        $('.slideshow-links .sublinks').children().each(function() {
          maxHeight = maxHeight > $(this).outerHeight() ? maxHeight : $(this).outerHeight();
        });
        $(this).outerHeight(maxHeight);
      });
    }
  }
  slideshowResize();
  
  $(document).on('click', '.transactions-sidebar-footer button', function(e){
    e.preventDefault();
    var t = $(this);
    var data = {};
    var enquiryForm = $(this).parents('.Drawer').find('#enquiry-form');
    if(enquiryForm.is(":visible")){
      var formItems = enquiryForm.find('.Form__Item');
      var action = 'https://api.hsforms.com/submissions/v3/integration/submit/4318542/78245737-a0a9-49d5-876a-8d67011129b8';
    }else{
      var formItems = $('#add-asset-form .Form__Item');
      var action = 'https://api.hsforms.com/submissions/v3/integration/submit/4318542/322ab231-69ec-48a6-bcb0-325203b76ea0';
    }
    
    var error = 0;
    var errorMsg = 'Please fill all required fields';
    data.fields = [];
    formItems.each(function(){
      var inputEl = $(this).find('[name^="contact"]');
      var fieldName = inputEl.attr('data-id');
      if(inputEl.is("select")){
        var fieldVal = inputEl.find('option:selected').val();
      }else if(inputEl.attr("type") == 'number'){
        var fieldVal = parseInt(inputEl.val());
      }else{
      	var fieldVal = capitalizeFirstLetter(inputEl.val());
      }
      if(inputEl.prop('required') && fieldVal == ''){
        $(this).addClass('error');
        error++;
      }else{
        $(this).removeClass('error');
      }
      if(inputEl.attr("type") == 'email'){
        var emailCheck = isEmail(fieldVal);
        if(!emailCheck){
          errorMsg = 'Please use correct email address';
          $(this).addClass('error');
          error++;
        }
      }

      
        var item = {};
        item.name = fieldName;
        item.value = fieldVal;
        data['fields'].push(item);
      
      
    });
    
    if(error > 0){
      $('#transactions-sidebar').find('.contact-feedback').text(errorMsg).removeClass('success').addClass('error');
      return false;
    }
    if(enquiryForm.is(":visible") && enquiryForm.find('.enquiry-title').val() != ''){
      var item = {};
      item.name='product_title';
      item.value=enquiryForm.find('.enquiry-title').val();
      data['fields'].push(item);
    }
    t.attr('disabled','disabled');
    if(!t.hasClass('processing')){
      t.addClass('processing');
      $.ajax({
        url: action,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        error: function(jqXHR, textStatus, errorThrown) {
          var errorMessage = JSON.parse(jqXHR.responseText);
          console.log(errorMessage);
          t.removeAttr('disabled');
          t.removeClass('processing');
          $('#transactions-sidebar').find('.contact-feedback').text('An error occured: '+errorMessage.errors[0].errorType).addClass('error').removeClass('success');
        },
        success: function(response) {
          t.removeAttr('disabled');
          t.removeClass('processing');
          enquiryForm.trigger('reset');
          $('#transactions-sidebar').find('.contact-feedback').text('Your enquiry has been received and we will be in touch.').addClass('success').removeClass('error');
        }
      });
    }
  });
  $(document).on('click','.transaction-sidebar-trigger:not(.cursor-disabled)', function(e){
    e.preventDefault();
    $(this).parents('.ProductItem').find('.enquire-button-wrapper').trigger('click');
    
  });
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh+'px');
  window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh+'px');
  
    slideshowResize();
  
  });
  
  function productTitleScroll(){
    if($('.product-header').hasClass('is-sticky')){
      var productTitleWidth = $('.product-header.is-sticky h1').width();
      var productTitleInner = $('.product-header.is-sticky h1 span').width();
      var diff = productTitleWidth - productTitleInner*0.8;
      $(":root").css("--titlex", productTitleWidth-productTitleInner +'px');
      $(":root").css("--titleduration", diff*-1+'s');
      
      if(productTitleWidth < productTitleInner){
        $('.product-header.is-sticky h1').addClass('marquee');
      }else{
        $('.product-header.is-sticky h1').removeClass('marquee');
      }
    }
  }
  if($('body').hasClass('template-product')){
    var productHeader = $('.product-header').offset().top - 70;
    
    $('.product-header').parent().css('height','auto');
    var productHeaderHeight = $('.product-header').outerHeight();
    $('.product-header').parent().outerHeight(productHeaderHeight);
    
    productTitleScroll();
  }
  if($('.template-suffix-media-center .media-scroll-bar').length){
    const mediaScrollEl = $('.page-section.media-scroll .media-scroll-bar');
    var mediaScroll = mediaScrollEl.offset().top - 70;
    
    mediaScrollEl.parent().css('height','auto');
    var mediaScrollHeight = mediaScrollEl.outerHeight();
    mediaScrollEl.parent().outerHeight(productHeaderHeight);
    
  }
  $(window).on('resize', function(){
    if($('body').hasClass('template-product')){
      
      $('.product-header').parent().css('height','auto');
      var productHeaderHeight = $('.product-header').outerHeight();
      $('.product-header').parent().outerHeight(productHeaderHeight);
      productTitleScroll();
    }
  });

  $(window).scroll(function() {
    if(productHeader){
      if ($(window).scrollTop() >= productHeader ) {
        $('.product-header').addClass('is-sticky');
    	var productHeaderSticky = $('.product-header.is-sticky').outerHeight();
        $('.product-header').parent().outerHeight(productHeaderSticky);
        productTitleScroll();
      }else{
        $('.product-header').removeClass('is-sticky');
    	$('.product-header').parent().outerHeight(productHeaderHeight);
      }
    }

    if($('.slideshow_v2.landing.version-2').length){
      const secondSection = $('.slideshow_v2.landing.version-2').parent().next();
      const secondSectionTop = secondSection.offset().top;
      const secondSectionHeight = secondSection.outerHeight();
      const secondSectionbottom = secondSectionTop + secondSectionHeight;
      const bottomWindow = $(window).scrollTop() + $(window).outerHeight();
      if (bottomWindow >= secondSectionbottom) {
        $('.sticky-bar').addClass('show');
      }else{
        $('.sticky-bar').removeClass('show');
      }
    }
    
    if(mediaScroll){
      const mediaScrollonPage = $('.page-section.media-scroll .media-scroll-bar');
      if ($(window).scrollTop() >= mediaScroll ) {
        mediaScrollonPage.addClass('is-sticky');
    	  var mediaScrollSticky = $('.media-scroll-bar.is-sticky').outerHeight();
        mediaScrollonPage.parent().outerHeight(mediaScrollSticky);
      }else{
        mediaScrollonPage.removeClass('is-sticky');
    	  mediaScrollonPage.parent().outerHeight(mediaScrollHeight);
      }
    }
  });

  function fetchMediaTags(){
    const $mediaData = $('.media-list-inner');
    const dataTags = [];
    $mediaData.children().each(function() {
      const dataTag = $(this).attr('data-tags');
      if (dataTag) {
        const dataTagSplit = dataTag.split(',');
        dataTagSplit.forEach(function(tag){
          dataTags.push(tag);
        })
      }
    });
    const uniqueDataTags = [...new Set(dataTags)];
    if(uniqueDataTags.length){
      $('.media-list-right .tags').empty();
      uniqueDataTags.forEach(function(tag){
        let locationClass = '';
        if($('.media-list-inner').attr('data-location-tags').includes(tag)){
          locationClass = ' location';
        }
        $('.media-list-right .tags').append(`<button class="tag-filter ${locationClass}" data-tag="${tag}">${tag}</button>`)
      })
    }

    $('.media-list-inner .post-tag').each(function(){
      if($('.media-list-inner').attr('data-location-tags').includes($(this).text())){
        $(this).addClass('location');
      }
    })
    
  }
  function displayMediaList(from,to,activetags=[]){
    let mediaList = $('.media-list-inner').children();
    if(from === 0){
      mediaList.addClass('hidden');
      $('.media-list-pagination button').attr('data-page', 2);
      scrollDown('#media-list');
    }

    if(activetags.length){
      mediaList = [];
      $('.media-list-inner').children().each(function(){
        const post = $(this);
        activetags.forEach(function(tag){
          if(post.attr('data-tags').includes(tag)){
            post.find(`.post-tag[data-tag="${tag}"]`).addClass('active');
            post.find(`.post-tag:not([data-tag="${tag}"])`).removeClass('active');
            mediaList.push(post);
          }
        })
      });
    }

    if(mediaList.length > to){
      $('.media-list-pagination').removeClass('hidden');
    }else{
      $('.media-list-pagination').addClass('hidden');
    }

    for(let i=from;i<to;i++){
      if($(mediaList[i]).length){
        $(mediaList[i]).removeClass('hidden');
        if(!activetags.length){
          $(mediaList[i]).find('.post-tag').removeClass('active');
        }
      }
    }
    $('.media-list-right .tags').children().removeAttr('disabled');
  }

  if ($('.media-list-inner').length) {
    const current_url = window.location.href.replace(/\/$/, '');
    const $mediaList = $('.media-list-inner');
    const postPerPage = parseInt($mediaList.attr('data-pagination'), 10);
  
    let page = 2;

    function loadAllExtendedMedia(callback) {
      function fetchNext() {
        const nextUrl = `${current_url}-${page}`;
        $.ajax({
          url: nextUrl,
          method: 'GET',
          dataType: 'html',
          success: function (response) {
            const $html = $('<div>').html(response);
            const $extended = $html.find('.media-list-extended');

            if ($extended.length) {
              $extended.each(function() {
                $mediaList.prepend($(this).html());
              });
              page++;
              fetchNext(); // keep going
            } else {
              callback(); // done if not found
            }
          },
          error: function () {
            callback(); // done if 404 or other error
          }
        });
      }
  
      fetchNext();
    }
  
    const $initialExtended = $('.media-list-extended');
    if ($initialExtended.length > 0) {
      $initialExtended.each(function() {
        $mediaList.prepend($(this).html());
        $(this).remove();
      });
  
      loadAllExtendedMedia(() => {
        $mediaList.find('.placeholder').remove();
        displayMediaList(0, postPerPage);
        fetchMediaTags();
      });
    } else {
      $mediaList.find('.placeholder').remove();
      displayMediaList(0, postPerPage);
      fetchMediaTags();
    }
  }
  
  $(document).on('click','.media-list-pagination button',function(e){
    e.preventDefault();
    const postPerPage = parseInt($('.media-list-inner').attr('data-pagination'));
    const page = parseInt($(this).attr('data-page'));
    const start = (page - 1)*postPerPage;
    const limit = page * postPerPage;
    const tagEl = $('.media-list-right .tags');
    const dataTags = getActiveTags(tagEl);

    $(this).attr('data-page', page + 1);
    displayMediaList(start,limit,dataTags);
  });

  $(document).on('click','.media-list-v2 button.tag-filter',function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    
    const from = 0;
    const postPerPage = parseInt($('.media-list-inner').attr('data-pagination'));
    const tagEl = $('.media-list-right .tags');
    const dataTags = getActiveTags(tagEl);

    $(this).attr('disabled','disabled').siblings().attr('disabled','disabled');
    displayMediaList(from,postPerPage,dataTags);
  });

  function fetchPlaceholder(){
    const randomNumber = Math.floor(Math.random() * (100 - 70 + 1)) + 70;
    const template = `<div class="post placeholder">
      <div class="post-text">
        <div class="post-meta">
          <div class="post-date"></div>
          <div class="post-meta-separator"></div>
          <div class="post-tags">
            <span class="post-tag"></span>
            <span class="post-tag"></span>
          </div>
        </div>
        <h3 class="post-title" style="width:${randomNumber}%"></h3>
        <p class="post-description">
          <span></span>
          <span style="width:${randomNumber}%"></span>
        </p>
        <div class="link"></div>
      </div>
      <div class="post-img">
        <div class="image-placeholder"></div>
      </div>
    </div>`;
    for (i = 0; i < 12; i++) {
      $('.blog-posts').append(template);
    }
  }
  function fetchBlogPosts(start,limit,activetags=[]){
    let postsList = '';
    let requests = [];
    let blogposts = $('.blog-posts-data').children();

    if(activetags.length){
      blogposts = [];
      $('.blog-posts-data').children().each(function(){
        const post = $(this);
        let found = 0;
        activetags.forEach(function(tag){
          if(post.attr('data-tags').includes(tag) && found < 1){
            blogposts.push(post);
            found++;
          }
        })
      });
    }

    if(blogposts.length > limit){
      $('.blog-pagination').removeClass('hidden');
    }else{
      $('.blog-pagination').addClass('hidden');
    }
    for (i = start; i < limit; i++) {
      if($(blogposts[i]).length){
        const url = `https://valustrat.com/pages/${$(blogposts[i]).text()}?view=plain`;
        const tags = $(blogposts[i]).attr('data-tags');
        const order = i;
        requests.push($.ajax({
          type: 'GET',
          url: url,
          success: function (html) {
            const postBlock = $(html);
            if(tags != ''){
              const tagsSplit = tags.split(',');
              let tagsMarkup = '';
              tagsSplit.forEach(function(item){
                let activeClass = '';
                if(activetags.includes(item)){
                  activeClass = ' active';
                }
                let locationClass = '';
                console.log(item);
                if($('.blog-posts-data').attr('data-location-tags').includes(item)){
                  locationClass = ' location';
                }
                tagsMarkup += `<span class="post-tag${activeClass}${locationClass}">${item}</span>`;
              });
              $(postBlock).find('.post-meta').append(tagsMarkup);
            }
            $(postBlock).find('.post').css('order',order);
            postsList += $(postBlock).html();
          },
          error: function (xhr, ajaxOptions, thrownError) {
            console.log(xhr.status);
            console.log(thrownError);
          }
        }));
      }
    }

    $.when.apply($, requests).then(function () {
      if (postsList) {
        if($('.blog-posts').find('.placeholder').length){
          $('.blog-posts').find('.placeholder').remove();
        }
        $('.blog-posts').append(postsList);
      }
      $('.blog-sidebar .tags').children().removeAttr('disabled');
    });
  }
  function fetchTags(){
    const $blogPostData = $('.blog-posts-data');
    const dataTags = [];
    $blogPostData.children().each(function() {
      const dataTag = $(this).attr('data-tags');
      if (dataTag) {
        const dataTagSplit = dataTag.split(',');
        dataTagSplit.forEach(function(tag){
          dataTags.push(tag);
        })
      }
    });
    const uniqueDataTags = [...new Set(dataTags)];
    if(uniqueDataTags.length){
      $('.blog-sidebar .tags').empty();
      uniqueDataTags.forEach(function(tag){
        let locationClass = '';
        if($('.blog-posts-data').attr('data-location-tags').includes(tag)){
          locationClass = ' location';
        }
        $('.blog-sidebar .tags').append(`<button class="tag-filter ${locationClass}" data-tag="${tag}">${tag}</button>`)
      })
    }
    
  }
  function getActiveTags(tagEl){
    const activeFilter = tagEl.find('.active');
    const dataTags = [];
    activeFilter.each(function(){
      dataTags.push($(this).attr('data-tag'));
    })
    return dataTags;
  }
  
  function clearBlogPosts(){
    $('.blog-posts').empty();
    $('.blog-pagination button').attr('data-page', 2);
    scrollDown('#blog-section');
  }

  if($('.posts-list').length > 0 && $('.blog-posts-data').length){
    $('.posts-list').each(function(){
      const listHTML = $(this).html();
      $('.blog-posts-data').prepend(listHTML);
      $(this).remove();
    });

    const start = 0;
    const limit = 12;
    fetchBlogPosts(start,limit);
    fetchTags(start,limit);

  }

  $(document).on('click','.blog-pagination button',function(e){
    e.preventDefault();
    const page = parseInt($(this).attr('data-page'));
    const start = (page - 1)*12;
    const limit = page * 12;
    const tagEl = $('.blog-sidebar .tags');
    const dataTags = getActiveTags(tagEl);

    $(this).attr('data-page', page + 1);
    fetchPlaceholder();
    fetchBlogPosts(start,limit,dataTags);
  });

  $(document).on('click','.blog-section button.tag-filter',function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    
    const start = 0;
    const limit = 12;
    const tagEl = $('.blog-sidebar .tags');
    const dataTags = getActiveTags(tagEl);

    $(this).attr('disabled','disabled').siblings().attr('disabled','disabled');
    clearBlogPosts();
    fetchPlaceholder();
    fetchBlogPosts(start,limit,dataTags);
  });

  $(document).on('click','.blog-posts .post-tag,.media-list-v2 .post-tag',function(e){
    e.preventDefault();
    const tag = $(this).text();
    $(`button.tag-filter[data-tag="${tag}"]`).trigger('click');
  });

  if($('.blog-section').length){
    const sectionTitle = $('.blog-section').find('.section-title');
    const tagsWrapper = $('.blog-section').find('.tags-wrapper');
    matchSize(sectionTitle,tagsWrapper,900)
  }
  
  if($('.media-list-v2').length){
    const sectionTitle = $('.media-list-v2').find('.section-title');
    const tagsWrapper = $('.media-list-v2').find('.tags-wrapper');
    matchSize(sectionTitle,tagsWrapper,900)
  }



  $(document).on('click','.video-controls',function(){
    if($(this).hasClass('youtube')){
      $(this).siblings('img').hide();
    }
    if($(this).hasClass('play')){
      $(this).prev().get(0).play();
      $(this).addClass('pause').removeClass('play');
    }else{
      $(this).prev().get(0).pause();
      $(this).removeClass('pause').addClass('play');
    }
  });
  $(document).on('click','.about-btn button',function(e){
    e.preventDefault();
    var t = $(this);
    
    $('.about-btn button').not($(this)).parents('.team-block-item').removeClass('expanded');
    $('.about-btn button').not($(this)).addClass('expand');
    
    if(t.hasClass('expand')){
      t.parents('.team-block-item').addClass('expanded');
      t.removeClass('expand');
    }else{
      t.parents('.team-block-item').removeClass('expanded');
      t.addClass('expand');
    }
    if(typeof teamBlockLanding != 'undefined'){
      teamBlockLanding.resize();
    }
  });
  $(document).on('click','.back-submenu',function(){
    $('[data-action="toggle-collapsible"][aria-expanded="true"]').attr('aria-expanded',false);
    $('.Collapsible').removeClass('expanded');
    $(this).toggleClass('hidden');
  })
  $(document).on('click','.Form__ItemHelp[data-action="toggle-recover-form"]',function(){
    $(this).parents('.account-sidebar-content').find('#recover_customer_password').fadeToggle();
    $(this).parents('.account-sidebar-content').find('#customer_login').fadeToggle();
  });
  $(document).on('click','#shopify-section-account-drawer .register-block a',function(e){
    e.preventDefault();
    $(this).parents('.account-sidebar-content').find('#create_customer').fadeToggle();
    $(this).parents('.account-sidebar-content').find('#customer_login').fadeToggle();
  });
  function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }

  $(document).on('submit','#shopify-section-account-drawer #customer_login',function(e){
    e.preventDefault();
    var t = $(this);
    var emailEl = t.find('[name="customer[email]"]');
    var passwordEl = t.find('[name="customer[password]"]');
    
    t.find('[type="submit"]').prop('disabled', true).text('Submitting...');
    
    var email = emailEl.val();
    var password = passwordEl.val();
    var data = {
      'customer[email]': email,
      'customer[password]': password,
      form_type: 'customer_login',
      utf8: '✓'
    };
    var err = 0;
    if(email == ''){
      emailEl.parent().addClass('error').append('<span class="form-error">This field is required.</span>');
      err++;
    }else if(!isEmail(email)){
      emailEl.parent().addClass('error').append('<span class="form-error">Please input correct email format.</span>');
      err++;
    }
    if(password == ''){
      passwordEl.parent().addClass('error').append('<span class="form-error">This field is required.</span>');
      err++;
    }
    if(err > 0){
  	  return false;
    }
    $.ajax({
      type: 'POST',
      url: '/account/login',
      data: data,
      dataType: 'html',
      async: true,
      success: function(html) {
    	t.find('[type="submit"]').prop('disabled', false).html('Login &nbsp;>');
        if (html.indexOf('Incorrect email or password.') !== -1) {
          emailEl.parent().addClass('error');
      	  passwordEl.parent().addClass('error');
          t.find('.account-feedback').addClass('error').text('Incorrect email or password.');
        } else {
          location.reload();
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log(xhr.status);
        console.log(thrownError);
      }
    });
  });
  $(document).on('submit','#shopify-section-account-drawer #create_customer',function(e){
    e.preventDefault();
    var t = $(this);
    var emailEl = t.find('[name="customer[email]"]');
    var passwordEl = t.find('[name="customer[password]"]');
    var firstNameEl = t.find('[name="customer[first_name]"]');
    var lastNameEl = t.find('[name="customer[last_name]"]');
    
    var email = emailEl.val();
    var password = passwordEl.val();
    var firstName = firstNameEl.val();
    var lastName = lastNameEl.val();
    
    t.find('[type="submit"]').prop('disabled', true).text('Submitting...');
    
    var data = {
      'customer[email]': email,
      'customer[password]': password,
      'customer[first_name]': firstName,
      'customer[last_name]': lastName,
      form_type: 'create_customer',
      utf8: '✓'
    };
    var err = 0;
    if(email == ''){
      emailEl.parent().addClass('error').append('<span class="form-error">This field is required.</span>');
      err++;
    }else if(!isEmail(email)){
      emailEl.parent().addClass('error').append('<span class="form-error">Please input correct email format.</span>');
      err++;
    }
    if(firstName == ''){
      firstNameEl.parent().addClass('error').append('<span class="form-error">This field is required.</span>');
      err++;
    }
    if(lastName == ''){
      lastNameEl.parent().addClass('error').append('<span class="form-error">This field is required.</span>');
      err++;
    }
    if(password == ''){
      passwordEl.parent().addClass('error').append('<span class="form-error">This field is required.</span>');
      err++;
    }
    if(err > 0){
  	  return false;
    }
    $.ajax({
      type: 'POST',
      url: '/account',
      data: data,
      dataType: 'html',
      async: true,
      success: function(html) {
    	t.find('[type="submit"]').prop('disabled', false).html('Sign Up &nbsp;>');
        
        if (html.indexOf('This email address is already associated with an account.') !== -1) {
          emailEl.parent().addClass('error');
          t.find('.account-feedback').addClass('error').text('This email address is already associated with an account.');
        }else if(html.indexOf('too short') !== -1) {
          passwordEl.parent().addClass('error');
          t.find('.account-feedback').addClass('error').text('Password is too short.');
        } else {
          emailEl.parent().removeClass('error');
          passwordEl.parent().removeClass('error');
          t.find('.account-feedback').addClass('success').text('Your account has been created.');
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log(xhr.status);
        console.log(thrownError);
      }
    });
  });

  if($('#forms-sidebar').length){
    $('#forms-sidebar .enquiry-form div').each(function(){
      var url = $(this).attr('data-url');
      var t= $(this);
      $.get(url, function( data ) {
        $(data).find('form').appendTo(t);     
      });
    });
  }
  $(document).on('click',"a[href*='?']",function(e) {
    var href = $(this).attr('href');
    var hash = href.split('?');
    var currentURL = window.location.href;
    if ($(this)[0].pathname == window.location.pathname) {
      e.preventDefault();
    }
    hash = hash[1].replace('service=','#accordion-');
    
	scrollDown(hash,e);
  });
  $(document).on('click', '[href*="#sidebar-form"]',function(e){
    e.preventDefault();
    if($(this).attr('href') == '#sidebar-form-add-asset' || $(this).attr('href') == '#sidebar-form-transactions'){
      var hash = $(this).attr('href');
      transactionSidebar(hash);
    }else{
      var formTitle = $(this).attr('href').replace('#sidebar-form-','').replace('-',' ');
      var formID = $(this).attr('href').replace('#sidebar-form-','');
      var linkLabel = $(this).text().replace('>','');
      formSidebar(formTitle,formID,linkLabel);
    }
  });

  $(document).on('click', '[href*="#sidebar-form"]',function(e){
    e.preventDefault();
    if($(this).attr('href') == '#sidebar-form-add-asset' || $(this).attr('href') == '#sidebar-form-transactions'){
      var hash = $(this).attr('href');
      transactionSidebar(hash);
    }else{
      var formTitle = $(this).attr('href').replace('#sidebar-form-','').replace('-',' ');
      var formID = $(this).attr('href').replace('#sidebar-form-','');
      var linkLabel = $(this).text().replace('>','');
      formSidebar(formTitle,formID,linkLabel);
    }
  });

  $(document).on('click', '.open-landing-form-sidebar',function(e){
    e.preventDefault();
    $('#landing-sidebar').attr('aria-hidden', false);
    $('#landing-sidebar #forms-enquiry').show();
    $('#landing-sidebar').find('.contact-feedback').text('').removeClass('error').removeClass('success');
    $('#landing-sidebar input:not([type="hidden"]):not([type="checkbox"]),#forms-sidebar textarea').val('');

    //$('#forms-sidebar .Drawer__Header h4').text(formTitle + ' Enquiry');
    $('.PageOverlay').addClass('is-visible forms-opened');
    $('html').addClass('no-scroll');
  });

  /*
  $(document).on('click','.team-view-more a',function(e){
    e.preventDefault();
    var t = $(this);
    t.parents('#main').addClass('team-expanded');
    
    var detailsEl = t.parents('.page-section-inner').next();
    var blockItem = t.parents('.team-block-item');
    var info = blockItem.find('.team-name');
    
    var name = info.find('span:first-child').html();
    var position = info.find('span:nth-child(2)').html();
    var details = blockItem.find('.team-detail-full').html();
    var img = blockItem.find('.team-image img').attr('src');
    const nameSplit = name.split(" ");
    let initials = nameSplit[0][0].toUpperCase();
    if (nameSplit[1]) {
      initials += nameSplit[1][0].toUpperCase();
    }
    detailsEl.removeClass('hidden');
    detailsEl.find('.team-name').children().not('.back-view-more').remove();
    detailsEl.find('.team-name').append(`
      <div class="team-detail-header">
        <div class="name-initial"><span>${initials}</span></div>
          <div class="name-position">
            <h1 class="team-member-name">${name}</h1>
            <span>${position}</span>
          </div>
        </div>
      </div>`);
    detailsEl.find('.team-details').empty().append(details);
    detailsEl.find('img').attr('src',img)
    
    $('html, body').animate({
      scrollTop: 0
    });
  })

  $(document).on('click','.back-view-more',function(e){
    e.preventDefault();
    var t = $(this);
    t.parents('#main').removeClass('team-expanded');
    t.parents('#main').find('.page-team-details').addClass('hidden');
    
  });*/


  $(document).on('click','.slideshow-links .links > div > a',function(){
    var index = $(this).attr('data-index');
    $(this).parent().siblings().find('a').removeClass('active');
    $(this).toggleClass('active');
    $('.slideshow-links .slideshow-sublinks:not([data-index="'+index+'"])').removeClass('visible');
    var activeLink = $('.slideshow-links .sublinks .slideshow-sublinks[data-index="'+index+'"]');

    if(activeLink.hasClass('visible')){
      activeLink.removeClass('visible');
      $(this).parents('.slideshow_v2').removeClass('hovered');
      
      if($('.sublinks-mobile').length){
        $('.sublinks-mobile').height(0);
        setTimeout(function(){
          $('.sublinks-mobile').remove();
        }, 300);
      }
      
    }else{
      $('.sublinks-mobile:not([data-index="'+index+'"])').height(0);
      setTimeout(function(){
        $('.sublinks-mobile:not([data-index="'+index+'"])').remove();
      }, 300);
      
      activeLink.addClass('visible');
      $(this).parents('.slideshow_v2').addClass('hovered');
      if ($(window).width() < 769) {
        activeLink.clone(true,true).addClass('sublinks-mobile').insertAfter($(this));
        var height = 0;
        $('.sublinks-mobile[data-index="'+index+'"]').children().each(function(){
          height = height + $(this).outerHeight(true);
        });
        $('.sublinks-mobile[data-index="'+index+'"]').outerHeight(height);
      }
    }
  });
  $(document).on({
    mouseenter: function (e) {
      e.preventDefault();
      var index = $(this).attr('data-index');
      var megamenu = $(this).parents('.MegaMenu');
      megamenu.find('.MegaMenu__Title').removeClass('active');
      $(this).find('.MegaMenu__Title').addClass('active');
      megamenu.find('.grandchild .Linklist').removeClass('active');
      megamenu.find('.grandchild .Linklist[data-index="'+index+'"]').addClass('active');
    },
    mouseleave: function () {
      $('.MegaMenu__Title').removeClass('active');
      $('.grandchild .Linklist:first-child').addClass('active');
      $('.grandchild .Linklist:not(:first-child)').removeClass('active');
    }
  }, '.child-parent .MegaMenu__Item');

  $(document).click(function(e) {
    let classes = ' ';
    if(e.target.className != ''){
      classes = JSON.stringify(e.target.className);
      if (!classes.includes("slideshow-links") && $(e.target).parents('.slideshow-links').length == 0) {
        $('.slideshow-links .active').removeClass('active');
        $('.slideshow-links .slideshow-sublinks').removeClass('visible');
        $('.slideshow_v2').removeClass('hovered');
        if($('.sublinks-mobile').length){
          $('.sublinks-mobile').height(0,true);
          setTimeout(function(){
            $('.sublinks-mobile').remove();
          }, 300);
        }
      }
      if (!classes.includes("Form__Checkbox") && $(e.target).parents('.Form__Checkbox').length == 0) {
        $('.Form__Checkbox.collapsible').removeClass('expanded');
        $('.Form__Checkbox.collapsible').find('.checkbox-wrapper').outerHeight(0);
      }
      if (!classes.includes("year-list") && $(e.target).parents('.year-list').length == 0) {
        $('.year-list').removeClass('expanded');
        $('.year-list ul').outerHeight(0);
      }
      
    }
  });
  $(document).on('click', '.forms-sidebar-footer button', function(e){
    e.preventDefault();
    var t = $(this);
    var data = {};
    t.attr('disabled','disabled');
    
    var action = $('#forms-enquiry .active').attr('data-hs-url');
    var formItems = $('#forms-enquiry .active').find('.Form__Item');
    var error = 0;
    var errorMsg = 'Please fill all required fields';
    data.fields = [];
    formItems.each(function(){
      
      var inputEl = $(this).find('[name^="contact"]');
      var fieldName = inputEl.attr('data-id');
      if(inputEl.is("select")){
        var fieldVal = inputEl.find('option:selected').val();
      }else if(inputEl.attr("type") == 'number'){
        var fieldVal = parseInt(inputEl.val());
      }else{
      	var fieldVal = capitalizeFirstLetter(inputEl.val());
        console.log(fieldVal);
      }
      if(inputEl.prop('required') && fieldVal == ''){
        $(this).addClass('error');
        error++;
      }else{
        $(this).removeClass('error');
      }
      if(inputEl.attr("type") == 'email'){
        var emailCheck = isEmail(fieldVal);
        if(!emailCheck){
          errorMsg = 'Please use correct email address';
          $(this).addClass('error');
          error++;
        }
      }
      
      if($(this).find(".Form__Checkbox").length){
        var fieldVal = $(this).find('.checkbox-wrapper').attr('data-value');
        if(!fieldVal){
          errorMsg = 'Please select at least 1 service';
          error++;
        }else{
          var fieldMap = fieldVal.split(',');
          fieldMap.forEach(function(t,i){
            var item = {};
            item.name = fieldName;
            item.value = t;
            data['fields'].push(item);
          });
        }
      }else{
        var item = {};
        item.name = fieldName;
        item.value = fieldVal;
        data['fields'].push(item);
      }
      
      
    });

    const storedGclid = sessionStorage.getItem("gclid");

    if (storedGclid && action.includes('817bd070-9f3d-4bf2-9142-d2f9a1a1a8c8')) {
      // Push new google_ad_click_id field
      data['fields'].push({
        name: "google_ad_click_id",
        value: storedGclid
      });
    }
    

    var hutk = getCookieGclid('hubspotutk'); // set by HubSpot tracking script

    data.context = {
      hutk: hutk,                       // links submission to tracked visitor
      pageUri: window.location.href,    // includes ?gclid=... if present
      pageName: document.title
    };
    
    if(error > 0){
      $('#forms-sidebar').find('.contact-feedback').text(errorMsg).addClass('error');
      return false;
    }
    
    if(!t.hasClass('processing')){
      t.addClass('processing');
      $('#forms-sidebar').find('.contact-feedback').text('').removeClass('error');
      $.ajax({
        url: action,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        error: function(jqXHR, textStatus, errorThrown) {
          var errorMessage = JSON.parse(jqXHR.responseText);
          t.removeAttr('disabled');
          t.removeClass('processing');
          $('#forms-sidebar').find('.contact-feedback').text('An error occured: '+errorMessage.errors[0].errorType).addClass('error').removeClass('success');
        },
        success: function(response) {
          t.removeAttr('disabled');
          t.removeClass('processing');
          t.parents('#forms-enquiry').find('.active form').trigger('reset');
          $('#forms-sidebar').find('.contact-feedback').text('Your enquiry has been received and we will be in touch.').addClass('success').removeClass('error');
        }
      });
    }
  
  });
  $(document).on('click','.checkout-trigger',function(e){
    e.preventDefault();
    var atc = $(this).parents('.ProductItem__Info').find('.atc-with-options');
    if(atc.length){
      atc.trigger('click');
    }
  });

  $(document).on('click','.uploadkit-button',function(e){
    $(this).parent().addClass('selecting-file');
  });
  $(document).on('click','.uploadcare--dialog__close',function(e){
    $('.selecting-file').removeClass('selecting-file');
  });
  $(document).on('click','.uploadcare--preview__done',function(e){
    $('.selecting-file').addClass('attached').removeClass('selecting-file error');
  });
  let lastScrollTop = 0;
  $(window).scroll(function() {
    var st = $(this).scrollTop();
      
    $(".parallax_element").each(function(){
      if(parallaxAnimate){
        var offset = 0;
        offset = offset - (st - $(this).parents('.parallax_parent').offset().top);
        offset = offset * -1;
        
        var transformY = offset * (parseFloat($(this).attr('data-friction')) / 50);
        
        $(this).css('transform','translate3d(0,'+transformY+'px,0)');
      }else{
        $(this).css('transform','translate3d(0,0,0)');
      }
    });
      

    if($('.blog-sidebar-not-used').length){
      const blogSidebar = $(".blog-sidebar");
      const stickyTop = blogSidebar.prev().offset().top;
      let topOffset = parseInt(blogSidebar.css('top')) + (lastScrollTop - st);

      if ($(this).scrollTop() >= stickyTop + blogSidebar.outerHeight() - $(this).height()) {
        const maxTop = $(this).height() - blogSidebar.outerHeight() - 30;
        if(topOffset < maxTop){
          topOffset = maxTop;
        }
      }
      if(topOffset > 30){
        topOffset = 30;
      }
      blogSidebar.css({
        position: "sticky",
        top: topOffset
      });
    }

    if($('.glossary-index-wrapper').length){
      if (st >= $('.glossary-index-wrapper').offset().top - $('#shopify-section-header').outerHeight()){
        $('.glossary-index').addClass('fixed');
        $('.glossary-index-wrapper').css('padding-bottom',$('.glossary-index').outerHeight());
      }else if(st < $('.glossary-index-wrapper').offset().top - $('#shopify-section-header').outerHeight()){
        $('.glossary-index').removeClass('fixed');
        $('.glossary-index-wrapper').css('padding-bottom',0);
      }

      $('.glossary-letter-index').each(function() {
        var elementTop = $(this).offset().top;
        if (st > elementTop - 200) {
            var letterId = $(this).data('letter');
            $('.glossary-index').find(`.glossary-letter[data-index="${letterId}"]`).addClass('active').siblings().removeClass('active');
        }
      });
    }

    lastScrollTop = st;
  });

  // set cookie according to you
  var cookieName= "gdpr_compliant";
  var cookieExpireDays= 30;
  // when users click accept button
  $('.accept-cookie').on('click',function(){
    var cookieValue="accept";
    createCookie(cookieName, cookieValue, cookieExpireDays);
  });
  $('.decline-cookie').on('click',function(){
    document.getElementById("cookie-consent").style.display = "none";
  });
  let createCookie= function(cookieName, cookieValue, cookieExpireDays){
    let currentDate = new Date();
    currentDate.setTime(currentDate.getTime() + (cookieExpireDays*24*60*60*1000));
    let expires = "expires=" + currentDate.toGMTString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    if(document.cookie){
      document.getElementById("cookie-consent").style.display = "none";
    }else{
      alert("Unable to set cookie. Please allow all cookies site from cookie setting of your browser");
    }
  }
  let getCookie= function(cookieName){
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  // check cookie is set or not
  let checkCookie= function(){
    let check=getCookie(cookieName);
    if(document.getElementById("cookie-consent")){
      if(check==""){
        document.getElementById("cookie-consent").style.display = "flex";
      }else{
        document.getElementById("cookie-consent").style.display = "none";
      }
    }
  }
  checkCookie();


  function getCookieGclid(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  //Landing
  $(document).on('click','.landing-cta a',function(e){
    if($(window).width() <= 900){
      $('.open-landing-form-sidebar').trigger('click');
    }else{
      scrollDown('#landing-form-wrapper',e,800);
    }
  });
  $(document).on('click','#landing-sidebar .sidebar-footer button',function(e){
    e.preventDefault();
    var t = $(this);
    var data = {};
    var form = $(this).parents('#landing-sidebar').find('form');
    var action = 'https://api.hsforms.com/submissions/v3/integration/submit/4318542/b1fe8522-ff54-4f6b-be4d-391b96ed6660';
    var formItems = form.find('.Form__Item:not(.submit-wrapper)');
    var error = 0;
    var errorMsg = 'Please fill all required fields';
    data.fields = [];
    formItems.each(function(){
      var inputEl = $(this).find('[name^="contact"]');
      var fieldName = inputEl.attr('data-id');
      if(inputEl.is("select")){
        var fieldVal = inputEl.find('option:selected').val();
      }else if(inputEl.attr("type") == 'number'){
        var fieldVal = parseInt(inputEl.val());
      }else if(inputEl.attr("type") != 'checkbox'){
      	var fieldVal = capitalizeFirstLetter(inputEl.val());
      }else{
        var fieldVal = capitalizeFirstLetter(inputEl.val());
      }
      if(inputEl.prop('required') && fieldVal == ''){
        $(this).addClass('error');
        error++;
      }else{
        $(this).removeClass('error');
      }
      if(inputEl.attr("type") == 'email'){
        var emailCheck = isEmail(fieldVal);
        if(!emailCheck){
          errorMsg = 'Please use correct email address';
          $(this).addClass('error');
          error++;
        }
      }
      
      if($(this).find(".Form__Checkbox").length){
        var fieldVal = $(this).find('.checkbox-wrapper').attr('data-value');
        if(!fieldVal){
          errorMsg = 'Please select at least 1 service';
          error++;
        }else{
          var fieldMap = fieldVal.split(',');
          fieldMap.forEach(function(t,i){
            var item = {};
            item.name = fieldName;
            item.value = t;
            data['fields'].push(item);
          });
        }
      }else{
        var item = {};
        item.name = fieldName;
        item.value = fieldVal;
        data['fields'].push(item);
      }
      
    });

    const storedGclid = sessionStorage.getItem("gclid");

    if (storedGclid) {
      // Push new google_ad_click_id field
      data['fields'].push({
        name: "google_ad_click_id",
        value: storedGclid
      });
    }

    var hutk = getCookieGclid('hubspotutk'); // set by HubSpot tracking script

    data.context = {
      hutk: hutk,                       // links submission to tracked visitor
      pageUri: window.location.href,    // includes ?gclid=... if present
      pageName: document.title
    };

    // Optional but recommended
    data.submittedAt = Date.now();
    
    if(error > 0){
      $('#landing-sidebar').find('.contact-feedback').text(errorMsg).addClass('error');
      return false;
    }
    
    t.attr('disabled','disabled');
    if(!t.hasClass('processing')){
      t.addClass('processing');
      $('#landing-sidebar').find('.contact-feedback').text('').removeClass('error');
      $.ajax({
        url: action,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        error: function(jqXHR, textStatus, errorThrown) {
          var errorMessage = JSON.parse(jqXHR.responseText);
          t.removeAttr('disabled');
          t.removeClass('processing');
          console.log(jqXHR);
          $('#landing-sidebar').find('.contact-feedback').text('An error occured: '+errorMessage.errors[0].errorType).addClass('error').removeClass('success');
        },
        success: function(response) {
          t.removeAttr('disabled');
          t.removeClass('processing');
          form.trigger('reset');
          $('#landing-sidebar').find('.contact-feedback').text('Your enquiry has been received and we will be in touch.').addClass('success').removeClass('error');
        }
      });
    }
  });
  $(document).on('submit', '#performance-form,#landing-form', function(e){
    e.preventDefault();
    var t = $(this);
    const submit_btn = t.find('[type="submit"]');
    var data = {};
    
    var action = 'https://api.hsforms.com/submissions/v3/integration/submit/4318542/b1fe8522-ff54-4f6b-be4d-391b96ed6660';
    var formItems = t.find('.Form__Item:not(.submit-wrapper)');
    var error = 0;
    var errorMsg = 'Please fill all required fields';
    data.fields = [];
    formItems.each(function(){
      var inputEl = $(this).find('[name^="contact"]');
      var fieldName = inputEl.attr('data-id');
      if(inputEl.is("select")){
        var fieldVal = inputEl.find('option:selected').val();
      }else if(inputEl.attr("type") == 'number'){
        var fieldVal = parseInt(inputEl.val());
      }else if(inputEl.attr("type") != 'checkbox'){
      	var fieldVal = capitalizeFirstLetter(inputEl.val());
      }else{
        var fieldVal = capitalizeFirstLetter(inputEl.val());
      }
      if(inputEl.prop('required') && fieldVal == ''){
        $(this).addClass('error');
        error++;
      }else{
        $(this).removeClass('error');
      }
      if(inputEl.attr("type") == 'email'){
        var emailCheck = isEmail(fieldVal);
        if(!emailCheck){
          errorMsg = 'Please use correct email address';
          $(this).addClass('error');
          error++;
        }
      }
      
      if($(this).find(".Form__Checkbox").length){
        var fieldVal = $(this).find('.checkbox-wrapper').attr('data-value');
        if(!fieldVal){
          errorMsg = 'Please select at least 1 service';
          error++;
        }else{
          var fieldMap = fieldVal.split(',');
          fieldMap.forEach(function(t,i){
            var item = {};
            item.name = fieldName;
            item.value = t;
            data['fields'].push(item);
          });
        }
      }else{
        var item = {};
        item.name = fieldName;
        item.value = fieldVal;
        data['fields'].push(item);
      }
      
    });
    
    const storedGclid = sessionStorage.getItem("gclid");

    if (storedGclid) {
      // Push new google_ad_click_id field
      data['fields'].push({
        name: "google_ad_click_id",
        value: storedGclid
      });
    }


    var hutk = getCookieGclid('hubspotutk'); // set by HubSpot tracking script

    data.context = {
      hutk: hutk,                       // links submission to tracked visitor
      pageUri: window.location.href,    // includes ?gclid=... if present
      pageName: document.title
    };

    if(error > 0){
      t.find('.contact-feedback').text(errorMsg).removeClass('success').addClass('error');
      return false;
    }
    submit_btn.attr('disabled','disabled');
    if(!t.hasClass('processing')){
      t.addClass('processing');
      t.find('.contact-feedback').text('').removeClass('error');
      $.ajax({
        url: action,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        error: function(jqXHR, textStatus, errorThrown) {
          var errorMessage = JSON.parse(jqXHR.responseText);
          submit_btn.removeAttr('disabled');
          t.removeClass('processing');
          t.find('.contact-feedback').text('An error occured: '+errorMessage.errors[0].errorType).addClass('error').removeClass('success');
        },
        success: function(response) {
          submit_btn.removeAttr('disabled');
          t.removeClass('processing');
          t.trigger('reset');
          t.find('.contact-feedback').text('Your enquiry has been received and we will be in touch.').addClass('success').removeClass('error');
        }
      });
    }
  
  });

  if($('.checkbox-wrapper').length){
    $('.checkbox-wrapper').attr('data-height',)
  }
  
  $(document).on('change','.Form__Checkbox input',function(e){
    var p = $(this).parents('.Form__Checkbox');
    var checkboxes = p.find('[name^="contact"]');
    var choosen = [];
    var count = 0;
    checkboxes.each(function(){
      if($(this).is(':checked')){
        choosen.push($(this).val());
        count++;
      }
    });
    var checkboxVal = choosen.toString();
    if(count > 0){
      p.find('.checkbox-wrapper').attr('data-value',checkboxVal);
      if(!$(this).parents('#landing-sidebar').length){
        p.find('h4.landing-label').text(checkboxVal);
      }
    }else{
      p.find('.checkbox-wrapper').attr('data-value','');
      if(!$(this).parents('#landing-sidebar').length){
        p.find('h4.landing-label').text(p.find('h4').attr('data-label'));
      }
    }
  });
  
  $(document).on('click','.Form__Checkbox.collapsible h4',function(e){
    e.preventDefault();
    var p = $(this).parent();
    p.toggleClass('expanded');
    var checkboxWrap = p.find('.checkbox-wrapper');
    if(p.hasClass('expanded')){
      checkboxWrap.outerHeight(checkboxWrap.find('.checkbox-inner').outerHeight());
    }else{
      checkboxWrap.outerHeight(0);
    }
  });

  $(document).on('click','.accordion-area',function(e){
    e.preventDefault();
    var parentHeight = $(this).find('.building-type').outerHeight() + 18;
    $('.accordion-area').not($(this)).each(function(){
      $(this).removeClass('expanded').outerHeight($(this).find('.building-type').outerHeight()+ 18);
    })
    if($(this).hasClass('expanded')){
      $(this).removeClass('expanded').outerHeight(parentHeight);
    }else{
      parentHeight += $(this).find('.area-list').outerHeight();
      $(this).addClass('expanded').outerHeight(parentHeight);
    }
  });
  $(document).on('click','.accordion-area .area-list',function(e){
    e.stopPropagation();
  });

  $(document).on('click','.vpi-toggle',function(){
    $(this).addClass('active').siblings().removeClass('active');
    var i = $(this).index() + 1;
    $('.vpi-graph-map > div:nth-child('+i+')').addClass('active').siblings().removeClass('active');
 })

  $(document).on('click','.vpi-accordion-heading-mobile .accordion-group-heading',function(){
    $(this).addClass('mobile-active').siblings().removeClass('mobile-active');
    var i = $(this).index() + 2;
    $('.accordion-group:nth-child('+i+')').addClass('mobile-active').siblings().removeClass('mobile-active');
  });

  $(document).on('click','.vpi-graph-title .year-list',function(){
    const ul = $(this).find('ul');
    let listHeight = 0;
    $(this).toggleClass('expanded');
    ul.children().each(function(){
      listHeight += $(this).outerHeight();
    });
    if($(this).hasClass('expanded')){
      ul.outerHeight(listHeight);
    }else{
      ul.outerHeight(0);
    }
  });
  
  function calcProgressBar(){
    const scrollPercent = 100 - (100 * $(window).scrollTop() / ($('.post-main').height() - $(window).height()));
    $('.scroll-progress-bar').css('clip-path', `inset(0px ${scrollPercent}% 0px 0px)`);
  }

  if($('.scroll-progress-bar').length){
    calcProgressBar();
    $(window).scroll(function(){
      calcProgressBar()
    });
    $(window).resize(function(){
      calcProgressBar()
    });
  }

  //if sessionStorage announcement is closed, remove announcement bar
  if(sessionStorage.getItem('announcement') != 'closed'){
    $('#section-announcement').removeClass('hidden');
    //calcViewport();
  }else{
    $('#section-announcement').remove();
  }

  $(document).on('click','.announcement-bar-close', function(){
    $('#section-announcement').css('margin-top', $('#section-announcement').outerHeight() * -1);
    setTimeout(function(){
      $('#section-announcement').remove();
      //calcViewport();
    }, 400);
    //save session storage
    sessionStorage.setItem('announcement', 'closed');
  });

  if(sessionStorage.getItem('announcement-banner') != 'closed'){
    $('#announcement-banner').removeClass('hidden');
    //calcViewport();
  }else{
    $('#announcement-banner').remove();
  }

  $(document).on('click','.close-announcement-banner', function(){
    setTimeout(function(){
      $('#announcement-banner').remove();
    }, 400);
    sessionStorage.setItem('announcement-banner', 'closed');
  });


  $(document).on('click','.glossary-letter', function(){
    const letter = $(this).data('index');
    const target = $(`.glossary-letter-index[data-letter="${letter}"]`);
    if(target.length){
      const offset = target.offset().top - 180;
      $('html, body').animate({
        scrollTop: offset
      });
    }
  });
  $(window).scroll(function(){
    if($(window).scrollTop() > $('.post-header').outerHeight()){
      $('.post-sticky-desktop').addClass('appear');
    }else{
      $('.post-sticky-desktop').removeClass('appear');
    }
  });


});




